module.exports = __webpack_public_path__ + "fa-light-300.b7412eb0b0d0a37deffbb70250b4011d.woff2";